import { render } from "./AddManualClaimComponent.vue?vue&type=template&id=2a3a8230"
import script from "./AddManualClaimComponent.vue?vue&type=script&lang=js"
export * from "./AddManualClaimComponent.vue?vue&type=script&lang=js"

import "./AddManualClaimComponent.vue?vue&type=style&index=0&id=2a3a8230&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__